import "animate.css";

import { Box, Chip, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
	green,
	red,
	orange,
	blue,
	yellow,
	brown,
	grey,
} from "@mui/material/colors";

function AddTags({ selectedTags, removeTag, addTag }) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const tags = [
		{ tag: "Meat", color: red },
		{ tag: "Chicken", color: orange },
		{ tag: "Fish", color: blue },
		{ tag: "Vegitarian", color: green },
		{ tag: "Rice", color: grey },
		{ tag: "Pasta", color: yellow },
		{ tag: "Potatoes", color: brown },
	];

	//const [pickedEmoji, setPickedEmoji] = useState();

	function updatePickedTags(tag) {
		const present = selectedTags.includes(tag);
		present ? removeTag(tag) : addTag(tag);
	}

	return (
		<Box paddingTop={3} textAlign="start">
			<Typography paddingTop={3} textAlign="start" variant="overline">
				Select the appropariate tags
			</Typography>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					gap: isMobile ? 1 : 2,
					justifyContent: "center",
					flexWrap: "wrap",
					maxWidth: isMobile ? 350 : 400,
					//backgroundColor: green[200],
				}}
			>
				{tags.map((item, i) => (
					<Chip
						key={i}
						sx={{
							backgroundColor: selectedTags.includes(item.tag)
								? item.color[100]
								: grey[50],
							color: item.color[900],
							fontWeight: "bold",
							borderRadius: "15px",
						}}
						onClick={() => {
							updatePickedTags(item.tag);
						}}
						label={item.tag}
					/>
				))}
			</Box>
		</Box>
	);
}
export default AddTags;
